export default __webpack_public_path__ + "static/media/brand-4.1a8adfd0.png";